export type ExpiresDateRangeValue = [Date | null, Date | null];

export function parseIsoDateString(value: string): Date | null {
  if (!value) {
    return null;
  }

  const [year, month, day] = value.split('-').map(Number);

  if (!year || !month || !day) {
    return null;
  }

  return new Date(year, month - 1, day);
}

export function formatIsoDateInput(date: Date | null): string {
  if (!date) {
    return '';
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function formatDisplayDate(date: Date): string {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
}

export function getExpiresDateRangeValue(value: unknown): ExpiresDateRangeValue {
  if (!Array.isArray(value)) {
    return [null, null];
  }

  const [from, to] = value;

  return [
    from instanceof Date && !Number.isNaN(from.getTime()) ? from : null,
    to instanceof Date && !Number.isNaN(to.getTime()) ? to : null,
  ];
}

export function startOfDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function endOfDay(date: Date): Date {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    23,
    59,
    59,
    999,
  );
}

export function formatExpiresAtDisplay(value: string): string {
  const date = parseIsoDateString(value);

  return date ? formatDisplayDate(date) : '';
}

/** Parses invitation `expiresAt` values stored as `YYYY-MM-DD`. */
export const parseExpiresAt = parseIsoDateString;
